import { getLocale } from '@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';
import { Header } from '@lwtears/lwt-common-frontend/lib/@common/util/header-util';
import LwtApi, { AuthStrategy } from '@lwtears/lwt-common-frontend/lib/@common/util/api-util';

const getHeaders = () => ({ [Header.LOCALE]: getLocale() });

export const getApi = function (authStrategy: AuthStrategy = AuthStrategy.AUTH_TOKEN) {
  return LwtApi()
    .addDefaultAuthStrategy(authStrategy)
    .options({ throwErrors: true })
    .addHeaders(getHeaders);
};

export * from './user';
export * from './telemetry';
